"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerBmField = exports.BmField = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@blue/element");

var _fieldStyles = require("../../field-styles");

var _stringUtils = require("../../../../render/items/input-fields/string-utils");

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t:host {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t}\n\t\t\t\t:host input:invalid {\n\t\t\t\t\tborder: 1px solid red;\n\t\t\t\t}\n\n\t\t\t\t:host sup {\n\t\t\t\t\tvisibility: hidden;\n\t\t\t\t}\n\t\t\t\t:host sup.actionRequired {\n\t\t\t\t\tvisibility: visible;\n\t\t\t\t}\n\n\t\t\t\t:host label {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tline-height: 14px;\n\t\t\t\t\tcolor: #37383d;\n\t\t\t\t\tfont-family: 'Helvetica Neue', Arial, sans-serif;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t}\n\n\t\t\t\t:host .bm-form-label {\n\t\t\t\t\tmargin-bottom: 9px;\n\t\t\t\t}\n\t\t\t\t.bm-form-nolabel {\n\t\t\t\t\theight: 4px;\n\t\t\t\t}\n\n\t\t\t\t:host .error-msg {\n\t\t\t\t\tcolor: #dc3545;\n\t\t\t\t\tfont-size: 80%;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tline-height: 2;\n\t\t\t\t}\n\t\t\t"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["<span class=\"error-msg\">", "</span>"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["<span class=\"bm-form-nolabel\"></span>"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<span class=\"bm-form-label\">\n\t\t\t\t", "\n\t\t\t\t<sup class=\"", "\"> *</sup>\n\t\t\t</span>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<label for=\"", "\">\n\t\t\t", "\n\t\t\t\t<slot></slot>\n\t\t\t\t", "\n\t\t\t</label>\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmField = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmField, _BlueElement);

  var _super = (0, _createSuper2.default)(BmField);

  function BmField() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.description = void 0;
    return _this;
  }

  (0, _createClass2.default)(BmField, [{
    key: "render",
    value: function render() {
      var name = (0, _stringUtils.sliceFromDelimiter)("".concat(this.name));
      return this.html(_templateObject(), name, this.renderLabel(this.label, this.required, this.editable), this.renderErrors());
    }
  }, {
    key: "renderLabel",
    value: function renderLabel(label, required, editable) {
      var actionRequired = required && editable;
      return label ? this.html(_templateObject2(), label, (0, _element.classMap)({
        actionRequired: actionRequired
      })) : this.html(_templateObject3());
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      return this.errors && this.errors.length > 0 && Boolean(this.errors[0]) ? this._renderErrors() : null;
    }
  }, {
    key: "_renderErrors",
    value: function _renderErrors() {
      return this.html(_templateObject4(), this.errors[0]);
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-field';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        name: {
          type: String,
          attribute: false,
          reflect: false
        },
        label: {
          type: String,
          attribute: true,
          reflect: true
        },
        description: {
          type: String,
          attribute: true,
          reflect: true
        },
        required: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        editable: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        errors: {
          type: Array,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [_fieldStyles.bmLabelStyles, (0, _element.css)(_templateObject5())];
    }
  }]);
  return BmField;
}(_element.BlueElement);

exports.BmField = BmField;

var registerBmField = function registerBmField() {
  return (0, _element.register)(BmField);
};

exports.registerBmField = registerBmField;
